export default "__VITE_ASSET__faa84e14__"